import type { InvitationPayload } from '@/invitation/payload/types';
import { orderedCouple } from '@/invitation/render/coupleOrder';
import { buildGoogleCalendarUrl } from '@/lib/invitation';

// Zona del evento: Bolivia (UTC−4, sin horario de verano). Espeja src/lib/event/rsvpDeadline.ts.
const EVENT_TZ_OFFSET = '-04:00';

/**
 * Construye la URL de "Agendar en mi calendario" (Google Calendar) a partir del payload.
 *
 * - Título: los nombres de la pareja, respetando el orden elegido (008 · US10).
 * - Fecha/hora: la fecha del evento (006) + la hora del primer evento con hora, o del primer
 *   momento del itinerario; si no hay hora, cae a las 12:00 (mediodía) de la zona del evento.
 * - Ubicación: la primera sede con nombre o dirección.
 *
 * Degrada con sensatez: si no hay fecha válida devuelve `null` (el botón queda sin acción).
 */
export function buildCalendarUrlFromPayload(p: InvitationPayload): string | null {
  const m = p.boda.fecha ? /^(\d{4})-(\d{2})-(\d{2})/.exec(p.boda.fecha) : null;
  if (!m) return null;
  const ymd = `${m[1]}-${m[2]}-${m[3]}`;

  const rawTime = p.eventos?.find((e) => e.hora)?.hora ?? p.itinerario?.find((it) => it.hora)?.hora;
  const tm = rawTime ? /^(\d{1,2}):(\d{2})/.exec(rawTime) : null;
  const hhmm = tm ? `${tm[1].padStart(2, '0')}:${tm[2]}` : '12:00';

  const weddingDate = new Date(`${ymd}T${hhmm}:00${EVENT_TZ_OFFSET}`);
  if (Number.isNaN(weddingDate.getTime())) return null;

  const { primero, segundo } = orderedCouple(p);
  const venue = p.eventos?.find((e) => e.sede || e.direccion);
  const location = [venue?.sede, venue?.direccion].filter(Boolean).join(', ') || undefined;

  return buildGoogleCalendarUrl({
    brideName: primero.nombreCorto,
    groomName: segundo.nombreCorto,
    weddingDate,
    location,
  });
}
